import React from "react";
import styles from "./Information.module.scss";
import { InformationProps } from "./Information.interface";

export const Information: React.FC<InformationProps> = (props) => {
  const { message, caption, onClose } = props;
  return (
    <div className={styles.information}>
      <div className={styles.formClose} onClick={onClose}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          fill="none"
        >
          <path
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="2"
            d="m4.757 4.757 8.486 8.486M4.757 13.243l8.486-8.486"
          />
        </svg>
      </div>
      <div className={styles.caption}>{caption}</div>
      <div className={styles.message}>{message}</div>
    </div>
  );
};
